export const SCHEDULE_EVENTS_TYPES = {
   lesson: 'lesson',
   exam: 'exam',
   reExam: 'recoveryExam',
   general: 'general',
   break: 'break'
}